import React, { Fragment } from "react";

import { PromoPackTypes } from "@utils/enums";

import { CartPromotionModel } from "@redux/modules/api/data/cart/@types/cart.model";

type Props = {
    promotions?: Array<CartPromotionModel>;
};

const VISIBLE_PROMOTION_TYPES = [
    PromoPackTypes.ZBON,
    PromoPackTypes.DOCUMENT_KORTING,
];

const PromotionItems = ({ promotions }: Props) => {
    const filteredPromotion = (promotions || []).filter(
        p =>
            p.commercialText !== null &&
            VISIBLE_PROMOTION_TYPES.includes(p.promotionType),
    );

    return (
        <Fragment>
            {filteredPromotion.length > 0 && (
                <div className="font-weight-bold text-success mb-3">
                    {filteredPromotion.map((promotion, index) => (
                        <div key={index}>{promotion.commercialText}</div>
                    ))}
                </div>
            )}
        </Fragment>
    );
};

export { PromotionItems };
